import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

export default function Footer() {
  const { lang, t } = useI18n();
  const base = `/${lang}`;

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0D1B2A] text-white pt-16 pb-8 border-t-4 border-[#D4AF37]"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-7">
          <div className="flex items-center gap-3">
            <span
              aria-hidden="true"
              className="inline-block h-8 w-8"
              style={{
                background:
                  "linear-gradient(180deg, #D4AF37 0%, #D4AF37 40%, #E0E1DD 40%, #E0E1DD 100%)",
              }}
            />
            <span
              className="text-2xl tracking-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {t("footer.brand")}
            </span>
          </div>
          <p className="mt-5 text-white/70 max-w-md text-sm leading-relaxed">
            {t("footer.tagline")}
          </p>

          <div className="mt-8 space-y-1.5 text-xs text-white/60 leading-relaxed">
            <p data-testid="footer-company-name" className="text-white/90 font-semibold">
              {t("footer.legalDetails.companyName")}
            </p>
            <p data-testid="footer-registration">{t("footer.legalDetails.registration")}</p>
            <p data-testid="footer-tax-id">{t("footer.legalDetails.taxId")}</p>
            <p data-testid="footer-license">{t("footer.legalDetails.license")}</p>
            <p data-testid="footer-jurisdiction">{t("footer.legalDetails.jurisdiction")}</p>
            <p data-testid="footer-address">{t("footer.legalDetails.address")}</p>
            <p data-testid="footer-since">{t("footer.legalDetails.since")}</p>
            <p data-testid="footer-contact">{t("footer.legalDetails.contact")}</p>
          </div>
        </div>

        <div className="md:col-span-5 md:pl-8">
          <h3 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-semibold">
            {t("footer.columns.legal")}
          </h3>
          <ul className="mt-5 space-y-3 text-sm">
            <li>
              <Link
                to={`${base}/privacy`}
                data-testid="footer-link-privacy"
                className="text-white/80 hover:text-[#D4AF37] no-underline"
              >
                {t("footer.links.privacy")}
              </Link>
            </li>
            <li>
              <Link
                to={`${base}/cookies`}
                data-testid="footer-link-cookies"
                className="text-white/80 hover:text-[#D4AF37] no-underline"
              >
                {t("footer.links.cookies")}
              </Link>
            </li>
            <li>
              <Link
                to={`${base}/terms`}
                data-testid="footer-link-terms"
                className="text-white/80 hover:text-[#D4AF37] no-underline"
              >
                {t("footer.links.terms")}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 md:px-8 mt-14 pt-6 border-t border-white/10 text-xs text-white/50">
        {t("footer.copyright")}
      </div>
    </footer>
  );
}
